export default "__VITE_ASSET__DWhkFlnW__"